import { render } from "./plan-rule.vue?vue&type=template&id=71530a5e&scoped=true&ts=true"
import script from "./plan-rule.vue?vue&type=script&lang=ts"
export * from "./plan-rule.vue?vue&type=script&lang=ts"

import "./plan-rule.vue?vue&type=style&index=0&id=71530a5e&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71530a5e"]])

export default __exports__